import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { BrokerApi } from '@apply/api';
import { applicationInsights } from '../ApplicationInsights';
import { formatDateTime } from '../common/SharedFunctions';

function AdminReferralSummary() {
    const brokerApi = new BrokerApi.BrokerApi(applicationInsights);

    const [lastLogins, set_lastLogins] = React.useState<[BrokerApi.ILastLogin] | null>(null);

    React.useEffect(() => {
        _loadLogins();
    }, []);

    const _loadLogins = async () => {
        const response = await brokerApi.getLastBrokerLogins(72);

        if (response.statusCode !== 200) return;

        set_lastLogins(response.result);
    };

    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center' as const,
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        loginPaper: {
            color: '#2C5591',
            padding: 20,
            fontSize: 14,
            margin: 20,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row' as const,
            justifyContent: 'space-evenly' as const,
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <div
                className='page-header'
                role='banner'
            >
                <h1>Referrals</h1>
            </div>
            <div
                className='row scrollable-content'
                style={styles.flexContainer}
            >
                <Link
                    to='/brokers'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Brokers</h1>
                        <p>Manage brokers getting setup on this system.</p>
                    </Paper>
                </Link>
                <Link
                    to='/brokerclients'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>B-Clients</h1>
                        <p>Manage Brokered Clients (&quot;B-Clients&quot;) getting setup on this system.</p>
                    </Paper>
                </Link>
                <div className='columns small-12 large-12'>
                    <h2 className='decorated'> </h2>
                </div>
                <div
                    className='columns small-12 large-12'
                    style={styles.flexContainer}
                >
                    <Paper
                        style={styles.loginPaper}
                        elevation={0}
                    >
                        <h6>Most Recent Brokers to Login (past 72 hours):</h6>
                        <table>
                            <tbody>
                                {lastLogins &&
                                    lastLogins.map((login, index) => (
                                        <tr key={index}>
                                            <td>
                                                {login.lastName}, {login.firstName}
                                            </td>
                                            <td>{login.businessName}</td>
                                            <td>
                                                <i>{formatDateTime(new Date(login.lastLoginDate + '+00:00'))}</i>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </Paper>
                </div>
            </div>
        </>
    );
}

export default AdminReferralSummary;
